import React, {useEffect, useState} from "react";
import {Row} from "reactstrap";
import {DialogActions, DialogContent, DialogTitle, Divider} from "@mui/material";
import useIsMounted from "../../../hooks/use-is-mounted";
import Dialog from "../../base/dialog";
import Api from "../../../../core/services/api/api";
import Button from "../../base/button/button";
import AvailableCreditsTable from "../../app-specific/available-credits-table";

const dataGridSaveConfig = {
    name: 'AddCreditToOrderDialogDataGrid',
    version: 1,
}


const AddCreditToOrderDialog = ({
                                    open,
                                    close,
                                    customerId,
                                    onAdd,
                                    onRemove,
                                    selectedCreditTransactionNos,
                                }) => {
    const [credits, setCredits] = useState([]);
    const [loading, setLoading] = useState(false);
    const [selecting, setSelecting] = useState(undefined);
    const isMounted = useIsMounted();

    /**
     * With each change in the [open] state of the dialog:
     * - fetches all the available credits of the provided customerId.
     */
    useEffect(() => {
        if (!open)
            return;
        getAllAvailableCredits().then();
    }, [open, customerId])

    /**
     * Loads the list of all available Credits for a specific customer and if the result of the api is successful,
     * sets the list
     */
    const getAllAvailableCredits = async () => {
        setLoading(true);
        const response = await Api.getAllAvailableCreditByCustomer(customerId)
        if (!isMounted())
            return;
        if (response?.resultFlag) {
            setCredits(response?.data ?? []);
        }
        setLoading(false);
    }

    /**
     * Calls the [onRemove] or [onAdd] callback based on whether this credit has been previously selected.
     * @param credit
     * @param isSelected
     * @return {Promise<void>}
     */
    const onCreditSelected = async (credit, isSelected) => {
        setSelecting(credit.id)
        if (isSelected) {
            await onRemove(credit);
        } else {
            await onAdd(credit);
        }
        if (!isMounted())
            return;
        setSelecting(undefined);
    }

    return (
        <Dialog
            open={open}
            setOpen={close}
            maxWidth={'md'}
            className={'bound-dialog'}
        >
            <DialogTitle>
                <Row xs={12} className='no-gutters justify-content-center p-3 w-100'>
                    <p className={`text-lg text-color-1 my-2 font-weight-semi-bold text-center`}>
                        Available Credits
                    </p>
                </Row>
                <Divider className='divider'/>
            </DialogTitle>
            <DialogContent>
                <AvailableCreditsTable
                    onSelect={onCreditSelected}
                    credits={credits}
                    loading={loading}
                    selectingCreditId={selecting}
                    selectedCreditTransactionNos={selectedCreditTransactionNos ?? []}
                    saveConfig={dataGridSaveConfig}
                />
            </DialogContent>
            <DialogActions>
                <Row className={'w-100 no-gutters'}>
                    <Divider className='divider'/>
                    <Row className='no-gutters justify-content-between align-items-start w-100'>
                        <Button
                            disabled={!open || loading}
                            variant={'dialog'}
                            onClick={() => close()}
                            borderRadius={'0 8px 0 8px'}
                        >
                            Close
                        </Button>
                    </Row>
                </Row>
            </DialogActions>
        </Dialog>
    );
}


export default AddCreditToOrderDialog;
